import React, { useEffect, useState } from "react";
import './CreateAccount.scss'
import { Controller, useForm } from 'react-hook-form';
import OnBoardingLookupService from '../../../../services/OnboardingService';
import DIContainer from '../../../../config/di.container';
import DITYPES from '../../../../config/di.types';
import OnBoardingRequestModel from "../../../../common/model/OnBoardingRequestModel";
import { OnBoardingLookupModel } from "../../../../common/model/OnBoardingLookupModel";
import { CountryModel } from "../../../../common/model/CountryModel";
import language from "../../../../util/en";
import ErrorMessage from "../../../shared/FormComponents/ErrorMessage/ErrorMessage";
import { AUPhoneRegex, EmailRegex, PhoneRegex, studioIdRegex, userDetailsLocalStorageKey, USPhoneRegex, websiteRegex } from "../../../../common/constant";
import { CreateAccountForm } from "../../../../common/model/CreateAccountForm";
import InfoIconWithMessage from "../../../shared/FormComponents/InfoIconLable/InfoIcon";
import { Form } from "react-bootstrap";
import Dropdown from "../../../shared/FormComponents/CustomDropdown/CustomDropdown";
import SelectSearch from "../../../shared/FormComponents/SelectSearchDropdown/SelectSearch";
import Region from "../../../../common/model/Region";
import CreateAccountRequest from "../../../../common/model/CreateAccountRequest";
import { EAccountCategory } from "../../../../common/enum/EAccountCategory";
import NotificationService from "../../../../services/NotificationService";
import { EErrorType } from "../../../../common/enum/EErrorType";
import { ECompanySize } from "../../../../common/enum/ECompanySize";
import { EPrimaryRole } from "../../../../common/enum/EPrimaryRole";
import UserDetails from "../../../../common/model/UserDetails";
import LocalStorageService from "../../../../services/local.storage.service";
import { useFlags } from 'launchdarkly-react-client-sdk';
import '../../Onboarding.scss';

export interface ICreateCompoentProp {
  handleOnChange: any;
  handleSubmit: any;
}

type RequiredFields = {
  firstName: string;
  lastName: string;
  businessName: string;
  website: string;
  email: string;
  phoneNumber: string;
  accountCategory: string;
  fieldName: string;
  aggreeToterms: string;
  subAccountCategory: [] | undefined;
};

let notificationService: NotificationService = DIContainer.get<NotificationService>(DITYPES.NotificationService);
const onboardingLookupService = DIContainer.get<OnBoardingLookupService>(DITYPES.OnboardingLookupService);
const localStorageService = DIContainer.get<LocalStorageService>(DITYPES.LocalstorageService);

const CreateAccount: React.FC<ICreateCompoentProp> = (props) => { 

  const [businessCategories, setBusinessCategories] = useState<OnBoardingLookupModel[]>();
  const [companySize, setCompanySize] = useState<OnBoardingLookupModel[]>();
  const [countries, setCountries] = useState<CountryModel[]>();
  const [primaryRoles, setPrimaryRoles] = useState<OnBoardingLookupModel[]>();
  const [phoneNumber, setPhoneNumber] = useState<any>('');
  const [phoneCode, setPhoneCode] = useState<any>('');
  const [isSubmitButtonDisabled, setSubmitButtonDisabled] = useState<boolean>(false);
  const [isUSPhoneFormat, setUSPhoneFormat] = useState<boolean>(true);

  const { register, watch, control, handleSubmit, setError, getValues, setValue, clearErrors, trigger, formState: { errors } } = useForm();

   //Feature flag launchdarkly//
   const  {showProfilePageNewFields}  = useFlags();

  useEffect(() => {
    console.log("ShowProfilePageNewFields",showProfilePageNewFields)
    setInitialFormValueFromLocal();
    
    (async () => {
      var response = await onboardingLookupService.getCreateAccountLookup(setupCreateAccountLookupRequestData());
      var updatedBusinessCategories = modifyUpdatedBusinessCategories(response.BusinessCategories);
      setBusinessCategories(updatedBusinessCategories);
      setCompanySize(response.CompanySize);
      setCountries(response.Countries);
      setPrimaryRoles(response.PrimaryRoles);
    })();

    createAccountForm.PhoneNumber = {
      FieldName: "phoneNumber", Label: "Phone number", ValidationAndEvent: {
        required: true, pattern: USPhoneRegex, onChange: (e) => { onChangeHandler(e) }, onBlur: (e) => { onChangeHandler(e) }
      }
    }

    setFormState(createAccountForm);
  }, [])

  

  const modifyUpdatedBusinessCategories = (updatedBusinessCategories: any) => {
    var filteredBusinessCategories = updatedBusinessCategories;
    var modifiedBusinessCategories: any = [];
    filteredBusinessCategories?.forEach((business) => {
      modifiedBusinessCategories.push(business);
      if (business.LookupList?.length > 0) {
        business.LookupList.forEach((subBusiness) => {
          subBusiness.Name = business.Name + ' - ' + subBusiness.Name;
          modifiedBusinessCategories.push(subBusiness);
        });
      }
    });
    return modifiedBusinessCategories;
  }
  const setInitialFormValueFromLocal = () => {
    var userDetails: UserDetails = new UserDetails();
    Object.assign(userDetails, JSON.parse(localStorageService.get(userDetailsLocalStorageKey) || '{}'));
    setValue("firstName", userDetails.FirstName);
    setValue("lastName", userDetails.LastName);
    setValue("email", userDetails.Email);
  }

  //This is used to update the progress//
  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      const { primaryRole, companySize, ...newObj } = value;
      updateProgessBar(newObj as RequiredFields);
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  //Update Progress bar//
  const updateProgessBar = (reqFields: RequiredFields) => {
    reqFields["phoneNumber"] = reqFields["phoneNumber"].substring(phoneCode.length, reqFields["phoneNumber"].length)
    reqFields["subAccountCategory"] = (reqFields["subAccountCategory"]?.length == 0) ? undefined : reqFields["subAccountCategory"];
    const emptyValues = new Set(["", null, undefined, false, Array(0)]);
    let count = (80 / Object.keys(reqFields).length) *
      (Object.keys(reqFields).length - Object.values(reqFields).filter(x => emptyValues.has(x)).length);
    props.handleOnChange("createAccount", count)
  }

  //Form Initilize//
  let createAccountForm: CreateAccountForm = {
    FirstName: {
      Label: "First name",
      FieldName: "firstName",
      ValidationAndEvent: {
        required: true, onChange: (e) => { onChangeHandler(e) }, onBlur: (e) => { onChangeHandler(e) }
      }
    },
    LastName: {
      Label: "Last name",
      FieldName: "lastName",
      ValidationAndEvent: {
        required: true, onChange: (e) => { onChangeHandler(e) }, onBlur: (e) => { onChangeHandler(e) }
      }
    },
    Email: {
      Label: "Email address",
      FieldName: "email",
      ValidationAndEvent: {
        required: true, pattern: EmailRegex, onChange: (e) => { onChangeHandler(e) }, onBlur: (e) => { onChangeHandler(e) }
      }
    },
    BusinessName: {
      Label: "Business name",
      FieldName: "businessName",
      ValidationAndEvent: {
        required: true, onChange: (e) => { onChangeHandler(e) }, onBlur: (e) => { onChangeHandler(e) }
      }
    },
    AccountCategory: {
      Label: "I am building this application for –",
      FieldName: "accountCategory"
    },
    Website: {
      Label: "Website",
      FieldName: "website",
      ValidationAndEvent: {
        required: true, pattern: websiteRegex, onChange: (e) => { onChangeHandler(e) }, onBlur: (e) => { onChangeHandler(e) }
      }
    },
    PhoneNumber: {
      Label: "Phone number",
      FieldName: "phoneNumber",
      ValidationAndEvent: {
        required: true, pattern: USPhoneRegex, onChange: (e) => { onPhoneNumberChangeHandler(e) }, onBlur: (e) => { onPhoneNumberChangeHandler(e) }
      }
    },
    Country: {
      Label: "Region of operation*", FieldName: "Country"
    },
    PrimaryRole: {
      FieldName: "primaryRole", Label: "Primary role"
    },
    CompanySize: {
      FieldName: "companySize", Label: "Company size"
    },
    SubAccountCategory: {
      FieldName: "subAccountCategory", Label: "Select a category that serves the primary purpose of the integration you’re building"
    },
    AggredToTerms: {
      FieldName: "aggreeToTems", Label: "I agree to the Mindbody"
    }
  }

  const [formState, setFormState] = useState<CreateAccountForm>(createAccountForm);

  const onChangeHandler = (event) => {
    trigger(event.target.name);
  }

  const onPhoneNumberChangeHandler = (event) => {
    var phoneNo = event.target.value.substring(phoneCode.length, event.target.value.length)

    if (isUSPhoneFormat) {
      phoneNo = getUSFormattedNumber(phoneNo)
    }
    else {
      phoneNo = phoneNo.replace(/[^0-9.]/g, "");
    }

    setPhoneNumber(phoneNo);
    setValue("phoneNumber", `${phoneCode}${phoneNo}`)
    trigger("phoneNumber");
  }

  const onRadioChangeHandler = (event: any) => {
    createAccountForm = formState;
    if (event.target.id == 'customRadio') {
      createAccountForm.InitialStudioId = {
        FieldName: "initialStudioId", Label: "Studio Id", ValidationAndEvent: {
          required: true, pattern: studioIdRegex, onChange: (e) => { onChangeHandler(e) }, onBlur: (e) => { onChangeHandler(e) }
        }
      }
      setFormState(createAccountForm);
    }
    else {
      createAccountForm.InitialStudioId = undefined;
      setFormState(createAccountForm);
    }
  }

  const onSearchDropdownChange = (value: any) => {
    createAccountForm = formState;
    createAccountForm.OtherSubAccountCategory = undefined;
    setFormState(createAccountForm);
    setValue('subAccountCategory', value);
  }

   //This is used to trigger the Phone number validation when formState is changed//
   useEffect(()=>{
    if(phoneNumber){
      trigger("phoneNumber");
    }        
},[formState])

  const getRegexByCountryCode = (value: any) => {
    switch (value) {
      case "US":
        return USPhoneRegex;
      case "AU":
        return AUPhoneRegex;
      default:
        return PhoneRegex;
    }
  };

  const onDropdownChangeHandler = (event: any) => {

    let phone;
    setUSPhoneFormat(event == "US");

    createAccountForm.PhoneNumber = {
      FieldName: "phoneNumber", Label: "Phone number", ValidationAndEvent: {
        required: true, pattern: getRegexByCountryCode(event), onChange: (e) => { onChangeHandler(e) }, onBlur: (e) => { onChangeHandler(e) }
      }
    }

    setFormState(createAccountForm);

    if (event == "US" && phoneNumber) {
      phone = getUSFormattedNumber(phoneNumber);
    }
    else {
      phone = phoneNumber?.replace(/[^0-9.]/g, "");
    }

    setPhoneNumber(phone);

    let code = countries?.filter(x => x.Code == event).map(e => e.PhoneCode)[0];   
    setValue("phoneNumber", `+${code} ${phone}`);
    setPhoneCode(`+${code} `);    
  }

  const getUSFormattedNumber = (phoneNumber: string): string => {
    let phoneNo = "";
    const input = phoneNumber?.replace(/\D/g, '');
    const zip = input.substring(0, 3);
    const middle = input.substring(3, 6);
    const last = input.substring(6, 10);

    if (input.length > 6) {
      phoneNo = `(${zip}) ${middle} - ${last}`;
    }
    else if (input.length > 3) {
      phoneNo = `(${zip}) ${middle}`;
    }
    else if (input.length > 0) {
      phoneNo = `(${zip}`;
    }

    return phoneNo;
  }

  const setupCreateAccountLookupRequestData = (): OnBoardingRequestModel => {
    var onBoardingRequest = new OnBoardingRequestModel();
    onBoardingRequest.IsCountry = true;
    onBoardingRequest.IsBusinessCategory = true;
    onBoardingRequest.IsCompanySize = true;
    onBoardingRequest.IsPrimaryRole = true;
    return onBoardingRequest;
  }

  const onSubmit = async (data) => {
    notificationService.notifyProgressSpinner(true);
    setSubmitButtonDisabled(true);

    await createAccountAPIRequest(data);
    setSubmitButtonDisabled(false);
    notificationService.notifyProgressSpinner(false);
  };

  const getAccountSubCategories = (selectedAccount: any) => {

    if(showProfilePageNewFields){
      let subBusinessCatrgoryId = parseInt(selectedAccount);
      selectedAccount = businessCategories?.find(x=>x.Id === subBusinessCatrgoryId)?.Name; 
    }
    var subBusinessCatrgories = Array<string>()
    if (selectedAccount) {
      subBusinessCatrgories.push(selectedAccount);
    }
    else {
      subBusinessCatrgories = [];
    }

    return subBusinessCatrgories;
  }

  const createAccountAPIRequest = async (data) => {
    try {
      var response = await onboardingLookupService.createAccountRequest(setUpCreatePartnerDetailsRequestBody(data));
      if (response) {
        notificationService.notifyToster("Account created successfully!", EErrorType.SUCCESS)
        props.handleSubmit("createaccount", 100);
      }
    }
    catch (errors) {
      console.log(errors)
    }
  }

  const setUpCreatePartnerDetailsRequestBody = (data) => {

    let partnerDetailsDTO = new CreateAccountRequest();
    partnerDetailsDTO.FirstName = data.firstName;
    partnerDetailsDTO.LastName = data.lastName;
    partnerDetailsDTO.Email = data.email;
    partnerDetailsDTO.BusinessName = data.businessName;
    partnerDetailsDTO.WebSite = data.website;
    partnerDetailsDTO.Phone = data.phoneNumber.replace(/[^ +-+a-zA-Z0-9]/g, '').replace(/([^\s]*\s[^\s]*)\s/g, "$1").replace(/([^\s]*\s[^\s]*)\s/g, "$1");

    partnerDetailsDTO.PrimaryRole = data.primaryRole ? Number(data.primaryRole) : EPrimaryRole.NotMentioned;
    partnerDetailsDTO.CompanySize = data.companySize ? Number(data.companySize) : ECompanySize.NotMentioned;
    partnerDetailsDTO.AgreeToTerms = data.aggredToTerms;
    partnerDetailsDTO.AccountCategory = EAccountCategory[String(data.accountCategory)];
    partnerDetailsDTO.InitialStudioID = data.initialStudioId ? Number(data.initialStudioId) : 0;
    partnerDetailsDTO.AccountSubCategories = getAccountSubCategories(data.subAccountCategory);
    partnerDetailsDTO.OtherSubAccountCategories = data.OtherSubAccountCategory;

    if(showProfilePageNewFields)
    {
      partnerDetailsDTO.AccountSubCategoryId = parseInt(data.subAccountCategory);
    }

    return partnerDetailsDTO;
  }

  return (
    <div className="ob-create-account-form" >
      <h2 className="ob-heading">{language.createAccount.Heading}</h2>
      <h4 className="ca-sub-heading">{language.createAccount.SubHeading}</h4>
      <div className="w-100">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="d-flex">
            {createAccountForm.FirstName &&
              <div className="wd-100">
                <label className="request-live-label">{createAccountForm.FirstName.Label}*</label>
                <input
                  {...register(createAccountForm.FirstName.FieldName, createAccountForm.FirstName.ValidationAndEvent)}
                  className="first-name-input disabled-field" type="text" disabled={true}
                  id="create-account-first-name" name="firstName" maxLength={25}
                ></input>
                <ErrorMessage errors={errors} {...createAccountForm.FirstName}></ErrorMessage>
              </div>
            }
            {createAccountForm.LastName &&
              <div className="wd-100">
                <div className="last-name-container">
                  <label className="request-live-label">{createAccountForm.LastName.Label}*</label>
                  <input {...register(createAccountForm.LastName.FieldName, createAccountForm.LastName.ValidationAndEvent)}
                    className="last-name-input disabled-field" type="text" id="create-account-last-name" disabled={true} maxLength={25}
                  >
                  </input>
                  <ErrorMessage errors={errors} {...createAccountForm.LastName}></ErrorMessage>
                </div>
              </div>
            }
          </div>
          {createAccountForm.Email &&
            <div className="padding-top-32">
              <label className="request-live-label">{createAccountForm.Email.Label}*</label>
              <input {...register(createAccountForm.Email.FieldName, createAccountForm.Email.ValidationAndEvent)}
                className="business-name-input disabled-field" type="text" id="create-account-email" disabled={true} maxLength={50}
              ></input>
              <span className="note-text">This email address will be used to send you important messages.</span>
              <ErrorMessage errors={errors} {...createAccountForm.Email} message={language.createAccount.IsValid}></ErrorMessage>
            </div>
          }
          {createAccountForm.BusinessName &&
            <div className="padding-top-32">
              <label className="request-live-label">{createAccountForm.BusinessName.Label}*</label>
              <input {...register(createAccountForm.BusinessName.FieldName, createAccountForm.BusinessName.ValidationAndEvent)}
                className="business-name-input" type="text" id="create-account-business-name" autoComplete="off" maxLength={50}
              ></input>
              <span className="note-text">You cannot change your business name later.</span>
              <ErrorMessage errors={errors} {...createAccountForm.BusinessName}></ErrorMessage>
            </div>
          }
          {createAccountForm.AccountCategory &&
            <div>
              {/* @ts-ignore */}
              <Controller
                control={control}
                name="accountCategory"
                rules={{ required: true }}
                render={({ field: { onChange, onBlur, value, ref },
                  fieldState: { invalid, isTouched, isDirty, error }
                }) => (
                  <div className="ca-radio-containter">
                    <Form.Label className="radio-button-label">
                      {language.createAccount.BuildingApplication}
                    </Form.Label>
                    <div className="d-flex">
                      <Form.Check
                        id="customRadio"
                        data-testid="customRadio"
                        type="radio"
                        label={language.createAccount.Custom}
                        onChange={(e) => onChange(e, onRadioChangeHandler(e))}
                        name="accountCategory"
                        value="Custom"
                      />
                    </div>
                    {formState.InitialStudioId &&
                      <div className="ca-studio">
                        <input {...register(formState.InitialStudioId.FieldName, formState.InitialStudioId.ValidationAndEvent)}
                          maxLength={10} autoComplete="off" placeholder={language.createAccount.EnterStudioId} className="business-name-input" type="text" id="caStudioId"
                        ></input>
                        <ErrorMessage errors={errors} {...formState.InitialStudioId} message={"must contain number only."}></ErrorMessage>
                      </div>
                    }
                    <div className="d-flex">
                      <Form.Check
                        id="commercialRadio"
                        data-testid="CommercialRadio"
                        type="radio"
                        label={language.createAccount.Commercial}
                        name="accountCategory"
                        onChange={(e) => onChange(e, onRadioChangeHandler(e))}
                        value="Commercial"
                      />
                    </div>
                    <ErrorMessage ignoreLabel={true} invalidCustomField={invalid} errors={errors}  {...createAccountForm.AccountCategory}></ErrorMessage>
                  </div>
                )}
              />
            </div>
          }
          {createAccountForm.Website &&
            <div className="padding-top-32">
              <label className="request-live-label">{createAccountForm.Website.Label}*</label>
              <input {...register(createAccountForm.Website.FieldName, createAccountForm.Website.ValidationAndEvent)}
                className="business-name-input" type="text" id="ob-create-account-website" autoComplete="off" maxLength={100}
              ></input>
              <ErrorMessage errors={errors} ignoreLabel={true} requiredMessage={language.createAccount.WebsiteReqError} {...createAccountForm.Website} message={language.createAccount.ValidURLMessage}></ErrorMessage>
            </div>
          }
          <div className="d-flex">
            {countries && countries.length > 0 &&
              <div className="padding-top-32 wd-47">
                <div className="inte-dr-div ca-2-field-div">
                  {/* @ts-ignore */}
                  <Controller control={control} name="country" rules={{ required: true }}
                    render={(
                      { field: { onChange, value, ref, ...field },
                        fieldState: { invalid }
                      }) => (
                      <Dropdown
                        {...field}
                        data={countries}
                        id="country"
                        value={value}
                        changeFunc={(value) => onChange(value, onDropdownChangeHandler(value))}
                        label={`${createAccountForm.Country.Label}`}
                        controlId="countryControlId"
                        isCheckMark
                        error={invalid}
                        valueField="Code"
                        labelField="CountryName"
                        setInitialValue={true}
                      />
                    )}
                  />
                </div>
              </div>
            }
            {formState.PhoneNumber &&
              <div className="padding-top-32 wd-47">
                <div className="ca-phone-container">
                  <label className="request-live-label">{formState.PhoneNumber.Label}*</label>
                  <input
                    {...register(formState.PhoneNumber.FieldName, formState.PhoneNumber.ValidationAndEvent)}
                    className="first-name-input" type="text" autoComplete="off" maxLength={25}
                    value={`${phoneCode}${phoneNumber}`}
                    onChange={onPhoneNumberChangeHandler} id="create-account-phone-number" name="phoneNumber"
                    onKeyPress={(e) => { (e.key === " " || e.key === "  ") && e.preventDefault() }}
                  ></input>
                  <ErrorMessage errors={errors} {...formState.PhoneNumber} message={"is invalid."}></ErrorMessage>
                </div>
              </div>
            }
          </div>
          {createAccountForm.PrimaryRole && primaryRoles &&
            <div className="padding-top-32">
              {/* @ts-ignore */}
              <Controller control={control} name="primaryRole"
                render={({ field: { onChange, onBlur, value, ref },
                  fieldState: { invalid, isTouched, isDirty, error }
                }) => (
                  <Dropdown
                    data={primaryRoles}
                    id="primaryRoles"
                    value={value}
                    changeFunc={onChange}
                    label={`${createAccountForm.PrimaryRole.Label}`}
                    controlId="primaryRoledata"
                    isCheckMark
                    error={invalid}
                    valueField="Id"
                    labelField="Name"
                  />
                )}
              />
            </div>
          }
          {createAccountForm.CompanySize && companySize &&
            <div className="padding-top-32">
              {/* @ts-ignore */}
              <Controller control={control} name="companySize"
                render={({ field: { onChange, onBlur, value, ref },
                  fieldState: { invalid, isTouched, isDirty, error }
                }) => (
                  <Dropdown
                    data={companySize}
                    id="companySize"
                    value={value}
                    changeFunc={onChange}
                    label={`${createAccountForm.CompanySize.Label}`}
                    controlId="companySizeData"
                    isCheckMark
                    valueField="Id"
                    labelField="Name"
                  />
                )}
              />
            </div>
          }
          {createAccountForm.SubAccountCategory && businessCategories && !showProfilePageNewFields && 
            <div className="padding-top-32">
              {/* @ts-ignore */}
              <Controller control={control} name="subAccountCategory" rules={{ required: true }}
                render={({ field: { onChange, onBlur, value, ref },
                  fieldState: { invalid, isTouched, isDirty, error }
                }) => (
                  <Dropdown
                    data={businessCategories}
                    id="subAccountCategory"
                    value={value}
                    changeFunc={(value) => onChange(value, onSearchDropdownChange(value))}
                    label={`${createAccountForm.SubAccountCategory.Label}*`}
                    controlId="subAccountCategory"
                    isCheckMark
                    valueField="Name"
                    labelField="Name"
                    error={invalid}
                    ignoreLabel={true}
                  />
                )}
              />
              {formState.OtherSubAccountCategory &&
                <div className="ca-studio">
                  <input {...register(formState.OtherSubAccountCategory.FieldName, formState.OtherSubAccountCategory.ValidationAndEvent)}
                    maxLength={100} autoComplete="off" placeholder={"Enter other business..."} className="business-name-input" type="text" id="ob-create-account-subaccountCategory"
                  ></input>
                  <ErrorMessage errors={errors} ignoreLabel={true} requiredMessage={language.createAccount.OtherBusinessReqError} {...formState.OtherSubAccountCategory}></ErrorMessage>
                </div>
              }
            </div>
          }
          {createAccountForm.SubAccountCategory && businessCategories && showProfilePageNewFields && 
            <div className="padding-top-32">
              {/* @ts-ignore */}
              <Controller control={control} name="subAccountCategory" rules={{ required: true }}
                render={({ field: { onChange, onBlur, value, ref },
                  fieldState: { invalid, isTouched, isDirty, error }
                }) => (
                  <Dropdown
                    data={businessCategories}
                    id="subAccountCategory"
                    value={value}
                    changeFunc={(value) => onChange(value, onSearchDropdownChange(value))}
                    label={`${createAccountForm.SubAccountCategory.Label}*`}
                    controlId="subAccountCategory"
                    isCheckMark
                    valueField="Id"
                    labelField="Name"
                    error={invalid}
                    ignoreLabel={true}
                  />
                )}
              />              
            </div>
          }
          {createAccountForm.AggredToTerms &&
            <div className="padding-top-32">
              <Controller control={control} name="aggredToTerms"
                rules={{ required: true }}
                render={({ field: { onChange, onBlur, value, ref },
                  fieldState: { invalid, isTouched, isDirty, error }
                }) => (
                  <div>
                    <div className="d-flex">
                      <Form.Check
                        type="checkbox"
                        label=""
                        value={value}
                        onChange={(e) => onChange(e, onChangeHandler(e))}
                        // onBlur={validateFields}
                        name="termsCondition"
                        data-testid="termsCondition"
                      />
                      <span className="api-term">
                        {" "}
                        {language.createAccount.IAgree}{" "}
                        <a id="btn-ob-ca-ftr-api-term" target="_blank" href="/Resources/DeveloperAgreement">
                          {language.createAccount.APITerms}
                        </a>
                      </span>
                    </div>
                    <ErrorMessage errors={errors} ignoreLabel={true} message={language.createAccount.IAgreeReqError} invalidCustomField={invalid} {...createAccountForm.AggredToTerms}></ErrorMessage>
                  </div>
                )}
              />

            </div>
          }
          <div className="text-align-center mb-5 mt-5">
            <div>
              <input id="ob-createAccount" disabled={isSubmitButtonDisabled} type="submit" value="Get Started" className="btn team3-left-button register w-button request-live-continue-button" />
            </div>
          </div>
        </form>
      </div>
    </div >
  )
}

export default CreateAccount;